const isSendSalesForce = () => {
    const url = window.location.href;
    return /\?salesforce/.test(url);
};
  
  export default isSendSalesForce;
  